import React from "react";
import { Box, CircularProgress } from "@mui/joy";

export const LoadingState: React.FC = () => (
  <Box display="flex" justifyContent="center" alignItems="center" height="100%">
    <CircularProgress size="lg" />
  </Box>
);
